// Extended catalog — links out to Shopify store for full checkout
export const SHOPIFY_URL = "https://r6vhrv-u7.myshopify.com";

export const HN_COLLECTIONS = [
  {
    id: "called-out-ones",
    title: "The Called Out Ones",
    tagline: "You didn't choose Him. He chose you.",
    accent: "#C0953A",
    items: [
      { name: "Believe", price: 48 },
      { name: "Peculiar", price: 48 },
      { name: "Chosen", price: 48 },
      { name: "Set Apart", price: 48 },
      { name: "Holy", price: 48 },
      { name: "Crown Ready", price: 48 },
      { name: "The Called Out Ones", price: 48 },
      { name: "Believe Hoodie", price: 78 },
    ],
  },
  {
    id: "kingdom-mindset",
    title: "Kingdom Mindset",
    tagline: "Rooted. Rising. Reigning.",
    accent: "#8FA88B",
    items: [
      { name: "Overflow", price: 48 },
      { name: "Overcome & Overflow", price: 48 },
      { name: "Rooted & Rising", price: 48 },
      { name: "Built to Reign", price: 48 },
      { name: "Dominion", price: 48 },
      { name: "Occupy", price: 48 },
    ],
  },
  {
    id: "love",
    title: "Love Collection",
    tagline: "Love is identity. Love is advantage.",
    accent: "#E85A6E",
    items: [
      { name: "Love Is a Choice", price: 48 },
      { name: "For the Love", price: 48 },
      { name: "Mercy Wins", price: 48 },
      { name: "Grace", price: 48 },
      { name: "Forgiven", price: 48 },
      { name: "Faith Over Fear", price: 48 },
      { name: "Grace T-Shirt Dress", price: 68 },
      { name: "Faith Over Fear Maxi Dress", price: 88 },
    ],
  },
  {
    id: "signature-sets",
    title: "Signature Sets",
    tagline: "Premium fleece. Tailored fit. Purposed detail.",
    accent: "#C0953A",
    items: [
      { name: "Known + Loved", price: 145 },
      { name: "More Than Conquerors", price: 165 },
      { name: "Dominion Tracksuit", price: 165 },
      { name: "Dominion — For the Queen", price: 165 },
    ],
  },
  {
    id: "statement-jackets",
    title: "The Statement Jackets",
    tagline: "You don't wear a brand. You rep a Kingdom.",
    accent: "#DCBB6C",
    items: [
      { name: "Rep the Kingdom Jacket", price: 175 },
      { name: "Trust the Process Jacket", price: 175 },
      { name: "Rep the Kingdom Denim", price: 155 },
    ],
  },
  {
    id: "luxe",
    title: "The Luxe Collection",
    tagline: "Where classic meets command.",
    accent: "#B2934A",
    items: [
      { name: "Coat of Many Colors — Reign Suit", price: 285 },
      { name: "Reign Blazer", price: 185 },
      { name: "Reign Vest Set", price: 195 },
      { name: "Reign Luxe Knit Set", price: 210 },
      { name: "Built to Reign Blazer Suit", price: 245 },
      { name: "Whirlwind Luxe Dress", price: 145 },
      { name: "Lioness Dress", price: 125 },
      { name: "Lioness Jumpsuit", price: 135 },
      { name: "Dominion Shirt Dress — Long Sleeve", price: 135 },
      { name: "Dominion Shirt Dress — Short Sleeve", price: 125 },
      { name: "The Reign Polo — Men's", price: 72 },
      { name: "The Reign Polo — Bubble Sleeve", price: 72 },
    ],
  },
  {
    id: "accessories",
    title: "Carry the Kingdom & Accessories",
    tagline: "Every piece has a purpose.",
    accent: "#8B6F3A",
    items: [
      { name: "Rep the Kingdom Tote", price: 42 },
      { name: "Trust the Process Tote", price: 42 },
      { name: "HN Crest Duffel", price: 95 },
      { name: "HN Tie Collection", price: 38 },
      { name: "HN Signature Handbag", price: 85 },
      { name: "HN Crest Duffel — Luxe", price: 110 },
    ],
  },
];
